import React, {useEffect, useState} from "react";
import { RepoFrame, RepositoryFrame } from "./Component";
// import { documentService } from '../api/document.service';
// import { RepositoryService } from "../api/repository.service";
import { useQuery } from "@tanstack/react-query";
import { RepositoryApi } from "../app/api/repository.api";
import { FolderApi } from "../app/api/folder.api";

const repInstance = RepositoryApi();
const folder = FolderApi();


// const docsInstance = documentService()

// export function DocContainer({data, isLoading, error})
// {
//     const [docModaleState, setdocModaleState] = useState(false);
//     const [isLoaderLoading, setIsLoaderLoading] = useState(false);
//     const [response , setResponse] = useState(-1)
//     const [message , setMessage] = useState('')
//     const [file, setFile] = useState('Uploader maintenant')
//     const [inputs, setInputs] = useState({})  
           
//     const handleInputs = ( event ) => {
//         const { name , value } =  event.target
//         if(name === 'file') { 
//             setInputs( { ...inputs, [name] : event.target.files[0] } )
//             setFile( event.target.files[0].name )
//         }
//         setInputs({ ...inputs, [name] : value  })
//     }
        
//     const handleForm = async ( event ) => {
//         event.preventDefault()
//         setIsLoaderLoading(true)
//         setdocModaleState(false)

//         const formData = new FormData()
//         formData.append('file', inputs.file)
//         formData.append('level', inputs.level)
//         formData.append('description', inputs.description)

//         // docsInstance.addDocument(formData)
//         // .then( res => { 
//         //     if( res.message === true ){
//         //         setMessage('Ajouté avec succes ') 
//         //         setResponse(1)
//         //     }
//         //     else{  
//         //         setMessage('Erreur ! veuillez réessayer') 
//         //         setResponse(0) 
//         //     }})
//         // .catch( err => {
//         //     setMessage('Erreur ! veuillez réessayer') 
//         //     setResponse(0)
//         // })     
//     }
    

//     return(
//         <div className="row">
//             {/* ******************************************************************************* */}
//             <div className="col-lg-12">
//                 { isLoaderLoading ? ( <LoaderModal message={message} response={response} close={ ()=> setIsLoaderLoading(false) } /> ) : null }
//             </div>
//             {/* ******************************************************************************* */}
//             <div className="col-lg-12">
//                { docModaleState ? ( <DocModal filename={file} text={'Uploader de nouveau documents'} close={ ()=> setdocModaleState(false) }  onChange={handleInputs} onSubmit={ handleForm } /> ) : null }
//             </div>
//             {/* ******************************************************************************* */}
//             <div className="col-lg-12 border-bottom mb-3">
//                 <div className="d-flex align-items-center justify-content-between pt-2 pb-3">  
//                     <span className="text-muted font-md"> Ajouter de nouveau document </span>
//                     <div className="d-flex"> <button className="btn btn-sm btn-green" onClick={ ()=> setdocModaleState(true) } > Ajouter </button> </div>
//                 </div>
//             </div>
//             <div className="col-lg-12 p-4">
//                 {/* -------------------------------------------------------- */}
//                 {   (isLoading) ? ( <div className="d-flex justify-content-center p-5">  <img className="" src={"../img/loader.gif"} alt="left-image" /> </div> ) : null }
//                 {/* -------------------------------------------------------- */}
//                 <div className="row mb-5"> 
//                     {
//                         ( Array.isArray(data) && data.length > 0  ) ?    
//                         ( data.map( (item, index )=> (
//                             <div className="col-lg-3 col-md-4 col-sm-6" key={ index }> 
//                                 <DocFrame name={ item.name } date={ item.date } path={ item.documentPath } /> 
//                             </div>
//                             ))
//                         ): null
//                     }
//                 </div> 
//                 {/* -------------------------------------------------------- */}
//                 {   (error) ? ( <div className="row d-flex justify-content-center p-5"> <div className="alert text-center alert-danger"> <span className="text-muted"> Erreur serveur interne </span> </div> </div> ) : null  } 
//                 {/* -------------------------------------------------------- */}
//             </div> 
//         </div>
//     )
// }




// export function VideoContainer({data, isLoading, error})
// {
//     const [docModaleState, setdocModaleState] = useState(false);
//     const [isLoaderLoading, setIsLoaderLoading] = useState(false);
//     const [response , setResponse] = useState(-1)
//     const [message , setMessage] = useState('')
//     const [file, setFile] = useState('Uploader maintenant')
//     const [inputs, setInputs] = useState({})  
           
//     const handleInputs = ( event ) => {
//         const { name , value } =  event.target
//         if(name === 'file') { 
//             setInputs( { ...inputs, [name] : event.target.files[0] } )
//             setFile( event.target.files[0].name )
//         }
//         setInputs({ ...inputs, [name] : value  }) 
//     }
        
//     const handleForm = async ( event ) => {
//         event.preventDefault()
//         setIsLoaderLoading(true)
//         setdocModaleState(false)

//         const formData = new FormData()
//         formData.append('file', inputs.file)
//         formData.append('level', inputs.level)
//         formData.append('description', inputs.description)

//         // docsInstance.addVideo(formData)
//         // .then( res => { 
//         //     if( res.message === true ){
//         //         setMessage('Ajouté avec succes ') 
//         //         setResponse(1)
//         //     }
//         //     else{  
//         //         setMessage('Erreur ! veuillez réessayer') 
//         //         setResponse(0) 
//         //     }})
//         // .catch( err => {
//         //     setMessage('Erreur ! veuillez réessayer') 
//         //     setResponse(0)
//         // })     
//     }

//     return(

//         <div className="row">
//             {/* ******************************************************************************* */}
//             <div className="col-lg-12">
//                 { isLoaderLoading ? ( <LoaderModal message={message} response={response} close={ ()=> setIsLoaderLoading(false) } /> ) : null }
//             </div>
//             {/* ******************************************************************************* */}
//             <div className="col-lg-12">
//                { docModaleState ? ( <DocModal filename={file} text={'Uploader de nouveau documents'} close={ ()=> setdocModaleState(false) }  onChange={handleInputs} onSubmit={ handleForm } /> ) : null }
//             </div>
//             {/* ******************************************************************************* */}
//             <div className="col-lg-12 border-bottom mb-3">
//                 <div className="d-flex align-items-center justify-content-between pt-2 pb-3">  
//                     <span className="text-muted font-md"> Ajouter un nouveau medias </span>
//                     <div className="d-flex"> <button className="btn btn-sm btn-green" onClick={ ()=> setdocModaleState(true) }> Ajouter </button> </div>
//                 </div>
//             </div>
//             <div className="col-lg-12 p-4">
//                 {/* -------------------------------------------------------- */}
//                 {   (isLoading) ? ( <div className="d-flex justify-content-center p-5">  <img className="" src={"../img/loader.gif"} alt="left-image" />  </div> ) : null }
//                 {/* -------------------------------------------------------- */}
//                 <div className="row mb-5"> 
//                     {
//                         ( Array.isArray(data) && data.length > 0  ) ?    
//                         ( data.map( (item, index )=> (
//                             <div className="col-lg-3 col-md-4 col-sm-6" key={ index }> 
//                                 <VideoFrame link={ item.link } date={ item.date } text={ item.description } /> 
//                             </div>
//                             ))
//                         ): null
//                     }
//                 </div> 
//                 {/* -------------------------------------------------------- */}
//                 {   (error) ? ( <div className="row d-flex justify-content-center p-5"> <div className="alert text-center alert-danger"> <span className="text-muted"> Erreur serveur interne </span> </div> </div> ) : null  } 
//                 {/* -------------------------------------------------------- */}
//             </div> 
//         </div>
//     )
// }




export function CollaboratorContainer({ data, isLoading, error})
{

    
    return(
        <div className="col-lg-12 p-4 scroll-lg bg-white border-bottom"> 
            {/* -------------------------------------------------------- */}
            {   (isLoading) ? ( <div className="d-flex justify-content-center p-5"> <div className="spinner-border text-success" style={{ width: "5rem", height: "5rem" }}  role="status" aria-label="Chargement"></div> </div> ) : null }
            {/* -------------------------------------------------------- */}
            <div className="row ps-3 pe-4"> 
                {
                    ( Array.isArray(data) && data.length > 0  ) ?    
                    ( data.map( (item, index )=> (
                        <div className="d-flex align-items-center justify-content-start gap-3 py-2 px-3 border rounded-2 mx-2 mb-4">  
                            <img src={ item.image } className="rounded-circle border border-3 p-1" alt="" width="40" />
                            <div className="d-flex flex-column">
                                <span className="text-muted"> { item.fname + ' ' + item.lname } </span>
                                <span className="small text-secondary"> { item.email } </span> 
                            </div>
                        </div>    
                        ))
                    ) : (  ( Array.isArray(data) && data.length === 0  ) ? ( <div className="alert text-center alert-success"> <span className="text-muted"> Pas encore de collaborateurs </span> </div> ) : null )
                }
            </div> 
            {/* -------------------------------------------------------- */}
            {   (error) ? ( <div className="row d-flex justify-content-center p-5"> <div className="alert text-center alert-danger"> <span className="text-muted"> Erreur serveur interne </span> </div> </div> ) : null  } 
            {/* -------------------------------------------------------- */}
        </div>
    )
}







export function UserContainer({ isLoading, error, data })
{

    return(
        <div className="row border-bottom bg-light">
            <div className="d-flex justify-content-center mb-3 py-3 border-bottom px-4 bg-white">
                <span className="lead text-secondary"> Information personelle </span> 
            </div>
            {/* -------------------------------------------------------- */}
            {   (isLoading) ? ( <div className="placeholder" style={{ height:'350px' }}> </div> ) : null }
            {/* -------------------------------------------------------- */}
            {   (error) ? ( 
                <div className="row d-flex justify-content-center p-5"> 
                    <div className="py-5 px-3 text-center bg-white border rounded"> 
                        <span className="text-secondary"> Erreur serveur interne </span> 
                    </div> 
                </div> ) : null  } 
            {/* -------------------------------------------------------- */}
    
            <div className="row d-flex px-4">
                <div className="col-lg-12 col-md-6 mb-2">
                    <div className="d-flex flex-column py-1">
                        <span className="font-xs text-muted pb-1 border-bottom px-2"> Prenom et nom : </span>
                        <span className="text-secondary mt-1 p-2"> { data?.fname + ' ' +  data?.lname } </span>
                    </div>
                </div>
                <div className="col-lg-12 col-md-6 mb-2">
                     <div className="d-flex flex-column py-1">
                         <span className="font-xs text-muted pb-1 border-bottom px-2"> Profession : </span>
                         <span className="text-secondary mt-1 p-2"> {  data?.occupation } </span>
                     </div>
                </div>
                <div className="col-lg-12 col-md-6 mb-2">
                     <div className="d-flex flex-column py-1">
                         <span className="font-xs text-muted pb-1 border-bottom px-2"> Université : </span>
                         <span className="text-secondary mt-1 p-2"> {  data?.institut } </span>
                     </div>
                </div> 
            </div>

        </div>
    )
}





export function RepositoryContainer()
{
    const fetchRepositories = async () => {
       await repInstance.findAll()
        .then( res => { console.log(res.data); return res.data } )
        .catch( err => { return err })
    };
                 
    const { data, error, isLoading } = useQuery({
        queryKey: ["repositories"],
        queryFn: fetchRepositories,
    });

    return(
        <div className="d-flex flex-column border bg-white rounded-2 p-3 scroll">
            {/* -------------------------------------------------------- */}
            {   (isLoading) && ( 
                <div className="d-flex justify-content-center p-4">  
                   <div className="spinner-border text-success" style={{ width: "5rem", height: "5rem" }}  role="status" aria-label="Chargement"></div>
                </div> ) 
            }
            {/* -------------------------------------------------------- */}
            <div className="d-flex flex-column">
                {    
                    ( Array.isArray(data) && data.length > 0  ) ?    
                    ( data.map( (item, index )=> (
                        <div className="d-flex align-items-center justify-content-start mb-3 p-2 border rounded-2" key={index}>  
                            <img src="../../img/icons8-signet-24.png" alt="" width="20" className="me-1" />
                            <a href={`/rep/${ item.id }`} className="link font-sm link-green-outline"> { item.name } </a>
                        </div>
                    ))
                    ) : (  ( Array.isArray(data) && data.length === 0  ) ? 
                           ( 
                               <div className="alert text-center alert-success"> 
                                   Liste de répertoire est vide 
                               </div> 
                           ) : null 
                        )    
                }
            </div> 
            {/* -------------------------------------------------------- */}
            {   (error) ? ( 
                    <div className="row d-flex justify-content-center px-4"> 
                        <div className="alert text-center alert-danger">  
                           Erreur serveur interne  
                        </div>
                    </div> 
                ) : null  
            } 
            {/* -------------------------------------------------------- */}
        </div> 
    )
}



export function RepositoriesContainer()
{

    const [name, setName] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const fetchRepository = async () => {
        const {data} = await repInstance.findAll();
        return data.data.owned;
    };

    const { data = [], error, isLoading } = useQuery({
        queryKey: ["allRepositories"],
        queryFn: fetchRepository,
    });

    useEffect(() => {
        setFilteredData(data);
    }, [data]);

                        
    const handleInputChange = (e) => {
        const value = e.target.value;
        setName(value);
        const filtered = data?.filter( (item) => item.name.toLowerCase().startsWith(value.toLowerCase()) );
        setFilteredData(filtered);
    };


    return(
       
        <div className="row">
            <div className="col-lg-12 p-4 border-bottom">
                <div className="d-flex w-100">
                    <div className="d-flex mb-2 mt-2 w-100">
                        <input type="search" name="name" value={ name } className="d-flex p-3 border input w-100 rounded-start text-secondary" placeholder="Nom répertoire" onChange={ handleInputChange } />
                        <div className="px-3 d-flex align-items-center justify-content-center rounded-end border color-green"> 
                            <i className="bi bi-search ms-2"></i>  
                        </div>
                    </div>
                </div>
            </div>
            {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
            <div className="col-lg-12">
                <div className="row"> 
                    <div className="col-lg-12 mb-4 border-bottom py-4 px-4">
                        <div> 
                            <a className="btn btn-sml btn-green" href="/nouveau-repertoire"> 
                                Nouveau répertoire <i className="bi bi-plus-circle ms-2"></i>  
                            </a> 
                        </div>
                    </div>
                    <div className="col-lg-12 mb-4 px-4">
                        <div className="bg-white border rounded text-secondary lead p-3"> Liste des répertoires </div>
                    </div>
                    {/* -------------------------------------------------------- */}
                    {   (isLoading) ? ( 
                        <div className="d-flex justify-content-center p-4">  
                           <div className="spinner-border text-success" style={{ width: "5rem", height: "5rem" }}  role="status" aria-label="Chargement"></div>
                        </div> ) : null 
                    }
                    {/* -------------------------------------------------------- */}
                    <div className="col-lg-12 mb-4 d-flex flex-column px-4">
                      <div className="d-flex flex-column scroll-xl border rounded-3 bg-white p-4">
                        {
                            ( Array.isArray(data) && data.length > 0  ) ?    
                            ( filteredData.map( (item, index )=> (
                                <RepositoryFrame name={ item.name } date={ item.createdAt } id={ item.id } key={ index } isShared={ item?.isShared } />
                            ))
                            ) : (  ( Array.isArray(data) && data.length === 0  ) ?
                               ( 
                                    <div className="alert text-center alert-danger"> 
                                        Liste de répertoires vide 
                                    </div> 
                                ) : null 
                            )
                        }             
                        {/* -------------------------------------------------------- */}
                        {   (error) ? ( 
                            <div className="row d-flex justify-content-center"> 
                                <div className="alert text-center alert-danger">  
                                   Erreur serveur interne  
                                </div>
                            </div> 
                        ) : null  
                        } 
                      </div>
                    </div> 
                    {/* -------------------------------------------------------- */}
                    

                </div> 
            </div> 
        </div>
            
    )
}




export function RepoContainer()
{

    const fetchRepository = async () => {
        const {data} = await repInstance.findAll();
        return data.data.owned;
    };
             
    const { data, error, isLoading } = useQuery({
        queryKey: ["allRepo"],
        queryFn: fetchRepository,
    });


    return(
       
        <div className="row">     
            <div className="col-lg-12 p-2">
                <div className="row"> 
                    <div className="col-lg-12 mb-4">
                        <div className="lead text-secondary border px-3 py-2"> Liste des répertoires </div>
                    </div>
                    {/* -------------------------------------------------------- */}
                    {   (isLoading) ? ( 
                        <div className="d-flex justify-content-center p-4">  
                           <div className="spinner-border text-success" style={{ width: "5rem", height: "5rem" }}  role="status" aria-label="Chargement"></div>
                        </div> ) : null 
                    }
                    {/* -------------------------------------------------------- */}
                    <div className="col-lg-12 mb-4 d-flex flex-column">
                      <div className="d-flex flex-column scroll-xl border rounded-3 bg-white p-4">
                        {
                            ( Array.isArray(data) && data.length > 0  ) ?    
                            ( data.map( (item, index )=> (
                                <RepoFrame name={ item.name } date={ item.date } id={ item.id } key={ index } isShared={ item?.isShared } />
                            ))
                            ) : (  ( Array.isArray(data) && data.length === 0  ) ?
                               ( 
                                    <div className="alert text-center alert-danger"> 
                                        Liste de répertoires vide 
                                    </div> 
                                ) : null 
                            )
                        }             
                        {/* -------------------------------------------------------- */}
                        {   (error) ? ( 
                            <div className="row d-flex justify-content-center"> 
                                <div className="alert text-center alert-danger">  
                                   Erreur serveur interne  
                                </div>
                            </div> 
                        ) : null  
                        } 
                      </div>
                    </div> 
                    {/* -------------------------------------------------------- */}
                    

                </div> 
            </div> 
        </div>
            
    )
}





export function PathContainer({ repId })
{

    const fetchRepository = async () => {
        const {data} = await repInstance.findOne( repId);
        return data.data;
    };
             
    const { data, isLoading } = useQuery({
        queryKey: ["repo"],
        queryFn: fetchRepository,
    });


    return(
       
        <div className="col-sm-8">
            <div className="d-flex align-items-center justify-content-start mt-2">  
                {
                    isLoading ? ( 
                      <span className="rounded-circle placeholder me-1" width="30" ></span> ) : ( 
                        
                      data ? ( <img src={ data?.owner.image } className="rounded-circle me-1" alt="" width={30} height={30}  /> ) : ( 
                          <span className="rounded-circle border bg-white me-1" style={{ width:'30px', height:'30px', borderRadius:'30px' }} ></span>
                      )
                        
                    )
                }
                {
                    isLoading ? ( <span class="placeholder"></span> ) : (

                        <div className="d-flex align-items-center text-secondary font-sm"> 
                            <a href="/panel" className="border px-3 py-1 rounded link text-success"> 
                                { data ? data?.owner.uname : 'Utilisateur inconnu' } 
                            </a> 
                            / { data ? ( <span className="ps-2" width="30" > { data?.name } </span> ) : 'Répertoire inconnu' } 
                        </div>
                    )
                }
            </div>
        </div>
            
    )
}



export function Path2Container({ folderId, repId })
{

    const fetchFolder = async () => {
        const {data} = await folder.findOne( folderId );
        return data.data;
    };
             
    const { data, isLoading } = useQuery({
        queryKey: ["Onefolder"],
        queryFn: fetchFolder,
    });


    return(
       
        <div className="col-sm-8">
            <div className="d-flex align-items-center justify-content-start mt-2">  
                {
                    isLoading ? ( 
                      <span className="rounded-circle placeholder me-1" width="30" ></span> ) : ( 
                        
                      data ? ( <img src={ data?.repository.owner.image } className="rounded-circle me-1" alt="" width="30" /> ) : ( 
                          <span className="rounded-circle border bg-white me-1" style={{ width:'30px', height:'30px', borderRadius:'30px' }} ></span>
                      )
                        
                    )
                }
                {
                    isLoading ? ( <span class="placeholder"></span> ) : (

                        <div className="d-flex align-items-center text-secondary font-sm"> 
                            <a href="/panel" className="border px-3 py-1 rounded link text-success"> 
                                { data ? data?.repository.owner.uname : 'Utilisateur inconnu' } 
                            </a> 
                            /
                            <a href={`/rep/${ repId }`} className="border px-3 py-1 rounded link text-success"> 
                                { data ? data?.repository.name : 'Répertoire inconnu' } 
                            </a> 
                            / 
                            { data ? ( <span className="ps-2" width="30" > { data?.name } </span> )  : 'Dossier inconnu' } 
                        </div>
                    )
                }
            </div>
        </div>
            
    )
}